import { render, staticRenderFns } from "./Blog_Single.vue?vue&type=template&id=77a0629d&scoped=true&"
import script from "./Blog_Single.vue?vue&type=script&lang=js&"
export * from "./Blog_Single.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a0629d",
  null
  
)

export default component.exports